module.exports = __webpack_public_path__ + "img/Bukayo Saka.4435fad3.png";